const SimpleModal2Heading = ({ title }: { title: string }) => {
  return (
    <div className='relative self-stretch -mt-px font-extrabold text-grey-s6 text-2xl text-center tracking-[0] leading-[normal] px-18 pt-14 pb-2'>
      {title}
    </div>
  )
}

export default SimpleModal2Heading
